var BPM_CRATE_SVG = require('./img/BPM_Crate.svg');
var BPM_CRATE_BLACK_SVG = require('./img/BPM_Crate_black.svg');
var BPM_CRATE_EMPTY_SVG = require('./img/BPM_Crate_empty.svg');
var BPM_CRATE_EMPTY_BLACK_SVG = require('./img/BPM_Crate_empty_black.svg');
var BPM_LATINO_LOGO_BLACK_SVG = require('./img/BPM_Latino_Logo_Black.svg');
var BPM_LATINO_LOGO_WHITE_SVG = require('./img/BPM_Latino_Logo_White.svg');
var BPM_SOUNDS_LOGO_SVG = require('./img/BPM_Sounds_Logo.svg');
var BPM_SOUNDS_LOGO_BLACK_SVG = require('./img/BPM_Sounds_Logo_Black.svg');
var BPM_SUPEME_LOGO_BLACK_SVG = require('./img/BPM_Supeme_Logo_Black.svg');
var BPM_SUPEME_LOGO_WHITE_SVG = require('./img/BPM_Supeme_Logo_White.svg');
var SERATO_FLIP_ICON_SVG = require('./img/Serato_Flip_Icon.svg');
var TR_SYNC_ICON_SVG = require('./img/TR_Sync_Icon.svg');
var ARROW_DOWN_SVG = require('./img/arrow_down.svg');
var ARROW_LEFT_SVG = require('./img/arrow_left.svg');
var ARROW_RIGHT_SVG = require('./img/arrow_right.svg');
var ARROWS_DOWN_SVG = require('./img/arrows_down.svg');
var ARROWS_LEFT_SVG = require('./img/arrows_left.svg');
var ARROWS_RIGHT_SVG = require('./img/arrows_right.svg');
var ARROWS_UP_SVG = require('./img/arrows_up.svg');
var AUDIO_SVG = require('./img/audio.svg');
var AUDIO_BLACK_SVG = require('./img/audio_black.svg');
var AUDIO_WHITE_SVG = require('./img/audio_white.svg');
var CHANGE_PASSWORD_SVG = require('./img/change_password.svg');
var CHECKMARK_BLUE_SVG = require('./img/checkmark-blue.svg');
var CHECKMARK_SVG = require('./img/checkmark.svg');
var CLOSE_SVG = require('./img/close.svg');
var CLOSE_BLUE_SVG = require('./img/close_blue.svg');
var CONTACT_SVG = require('./img/contact.svg');
var CONTACT_WHITE_SVG = require('./img/contact_white.svg');
var CRATE_SVG = require('./img/crate.svg');
var CRATE_BLACK_SVG = require('./img/crate_black.svg');
var CURATED_SETS_SVG = require('./img/curated_sets.svg');
var CURATED_SETS_BLACK_SVG = require('./img/curated_sets_black.svg');
var CURATED_SETS_SELECTED_SVG = require('./img/curated_sets_selected.svg');
var DOWNLOAD_BLUE_SVG = require('./img/download-blue.svg');
var DOWNLOAD_SVG = require('./img/download.svg');
var DROP_DOWN_CARRET_SVG = require('./img/drop_down_carret.svg');
var DROP_DOWN_CARRET_BLACK_SVG = require('./img/drop_down_carret_black.svg');
var EQUALIZER_SVG = require('./img/equalizer.svg');
var EXCLUSIVE_TAG_SVG = require('./img/exclusive_tag.svg');
var FULLSCREEN_SVG = require('./img/fullscreen.svg');
var FULLSCREEN_WHITE_SVG = require('./img/fullscreen_white.svg');
var HOME_SVG = require('./img/home.svg');
var HOME_WHITE_SVG = require('./img/home_white.svg');
var ICON_CLASSIC_SVG = require('./img/icon_classic.svg');
var ICON_CLASSIC_BLUE_SVG = require('./img/icon_classic_blue.svg');
var ICON_SMART_SVG = require('./img/icon_smart.svg');
var ICON_SMART_BLUE_SVG = require('./img/icon_smart_blue.svg');
var IMAGE_PLACEHOLDER_SVG = require('./img/image_placeholder.svg');
var INFO_SVG = require('./img/info.svg');
var LOADING_SVG = require('./img/loading.svg');
var LOGOUT_SVG = require('./img/logout.svg');
var LOGOUT_WHITE_SVG = require('./img/logout_white.svg');
var MINUS_BLUE_SVG = require('./img/minus-blue.svg');
var MINUS_SVG = require('./img/minus.svg');
var MORE_SVG = require('./img/more.svg');
var MORE_WHITE_SVG = require('./img/more_white.svg');
var MY_ACCOUNT_SVG = require('./img/my_account.svg');
var MY_ACCOUNT_WHITE_SVG = require('./img/my_account_white.svg');
var MY_PROFILE_SVG = require('./img/my_profile.svg');
var NEW_RELEASES_SVG = require('./img/new_releases.svg');
var NEW_RELEASES_BLACK_SVG = require('./img/new_releases_black.svg');
var NEW_RELEASES_SELECTED_SVG = require('./img/new_releases_selected.svg');
var NEWS_SVG = require('./img/news.svg');
var NEWS_BLACK_SVG = require('./img/news_black.svg');
var NEWS_SELECTED_SVG = require('./img/news_selected.svg');
var PAUSE_SMALL_SVG = require('./img/pause_small.svg');
var PAUSE_SMALL_WHITE_SVG = require('./img/pause_small_white.svg');
var PLATFORM_SVG = require('./img/platform.svg');
var PLATFORM_GRAY_SVG = require('./img/platform_gray.svg');
var PLAY_GRAY_SVG = require('./img/play_gray.svg');
var PLAY_SMALL_SVG = require('./img/play_small.svg');
var PLAY_SMALL_WHITE_SVG = require('./img/play_small_white.svg');
var PLAY_WHITE_SVG = require('./img/play_white.svg');
var PLUS_BLUE_SVG = require('./img/plus-blue.svg');
var PLUS_SVG = require('./img/plus.svg');
var PROFILE_PICTURE_SVG = require('./img/profile_picture.svg');
var QUEUE_SVG = require('./img/queue.svg');
var RADIO_CHARTS_SVG = require('./img/radio_charts.svg');
var RADIO_CHARTS_BLACK_SVG = require('./img/radio_charts_black.svg');
var RADIO_CHARTS_SELECTED_SVG = require('./img/radio_charts_selected.svg');
var SEARCH_SVG = require('./img/search.svg');
var SERATO_SVG = require('./img/serato.svg');
var SETTINGS_SVG = require('./img/settings.svg');
var SHUFFLE_SVG = require('./img/shuffle.svg');
var SHUFFLE_GRAY_SVG = require('./img/shuffle_gray.svg');
var SHUFFLE_WHITE_SVG = require('./img/shuffle_white.svg');
var SPEAKER_SVG = require('./img/speaker.svg');
var SPEAKER_WHITE_SVG = require('./img/speaker_white.svg');
var STATS_AUDIO_SVG = require('./img/stats_audio.svg');
var STATS_CALENDAR_SVG = require('./img/stats_calendar.svg');
var STATS_VIDEO_SVG = require('./img/stats_video.svg');
var SUPPORT_SVG = require('./img/support.svg');
var SUPPORT_WHITE_SVG = require('./img/support_white.svg');
var TOP_DOWNLOADS_SVG = require('./img/top_downloads.svg');
var TOP_DOWNLOADS_BLACK_SVG = require('./img/top_downloads_black.svg');
var TOP_DOWNLOADS_SELECTED_SVG = require('./img/top_downloads_selected.svg');
var TRASH_SVG = require('./img/trash.svg');
var TRASH_BLUE_SVG = require('./img/trash_blue.svg');
var VIDEO_SVG = require('./img/video.svg');
var VIDEO_BLACK_SVG = require('./img/video_black.svg');
var VIDEO_WHITE_SVG = require('./img/video_white.svg');
var VOLUME_0_SVG = require('./img/volume-0.svg');
var VOLUME_1_SVG = require('./img/volume-1.svg');
var VOLUME_2_SVG = require('./img/volume-2.svg');
export { BPM_CRATE_SVG, BPM_CRATE_BLACK_SVG, BPM_CRATE_EMPTY_SVG, BPM_CRATE_EMPTY_BLACK_SVG, BPM_LATINO_LOGO_BLACK_SVG, BPM_LATINO_LOGO_WHITE_SVG, BPM_SOUNDS_LOGO_SVG, BPM_SOUNDS_LOGO_BLACK_SVG, BPM_SUPEME_LOGO_BLACK_SVG, BPM_SUPEME_LOGO_WHITE_SVG, SERATO_FLIP_ICON_SVG, TR_SYNC_ICON_SVG, ARROW_DOWN_SVG, ARROW_LEFT_SVG, ARROW_RIGHT_SVG, ARROWS_DOWN_SVG, ARROWS_LEFT_SVG, ARROWS_RIGHT_SVG, ARROWS_UP_SVG, AUDIO_SVG, AUDIO_BLACK_SVG, AUDIO_WHITE_SVG, CHANGE_PASSWORD_SVG, CHECKMARK_BLUE_SVG, CHECKMARK_SVG, CLOSE_SVG, CLOSE_BLUE_SVG, CONTACT_SVG, CONTACT_WHITE_SVG, CRATE_SVG, CRATE_BLACK_SVG, CURATED_SETS_SVG, CURATED_SETS_BLACK_SVG, CURATED_SETS_SELECTED_SVG, DOWNLOAD_SVG, DOWNLOAD_BLUE_SVG, DROP_DOWN_CARRET_SVG, DROP_DOWN_CARRET_BLACK_SVG, EQUALIZER_SVG, EXCLUSIVE_TAG_SVG, FULLSCREEN_SVG, FULLSCREEN_WHITE_SVG, HOME_SVG, HOME_WHITE_SVG, ICON_CLASSIC_SVG, ICON_CLASSIC_BLUE_SVG, ICON_SMART_SVG, ICON_SMART_BLUE_SVG, IMAGE_PLACEHOLDER_SVG, INFO_SVG, LOADING_SVG, LOGOUT_SVG, LOGOUT_WHITE_SVG, MINUS_BLUE_SVG, MINUS_SVG, MORE_SVG, MORE_WHITE_SVG, MY_ACCOUNT_SVG, MY_ACCOUNT_WHITE_SVG, MY_PROFILE_SVG, NEW_RELEASES_SVG, NEW_RELEASES_BLACK_SVG, NEW_RELEASES_SELECTED_SVG, NEWS_SVG, NEWS_BLACK_SVG, NEWS_SELECTED_SVG, PAUSE_SMALL_SVG, PAUSE_SMALL_WHITE_SVG, PLATFORM_SVG, PLATFORM_GRAY_SVG, PLAY_GRAY_SVG, PLAY_SMALL_SVG, PLAY_SMALL_WHITE_SVG, PLAY_WHITE_SVG, PLUS_BLUE_SVG, PLUS_SVG, PROFILE_PICTURE_SVG, QUEUE_SVG, RADIO_CHARTS_SVG, RADIO_CHARTS_BLACK_SVG, RADIO_CHARTS_SELECTED_SVG, SEARCH_SVG, SERATO_SVG, SETTINGS_SVG, SHUFFLE_SVG, SHUFFLE_GRAY_SVG, SHUFFLE_WHITE_SVG, SPEAKER_SVG, SPEAKER_WHITE_SVG, STATS_AUDIO_SVG, STATS_CALENDAR_SVG, STATS_VIDEO_SVG, SUPPORT_SVG, SUPPORT_WHITE_SVG, TOP_DOWNLOADS_SVG, TOP_DOWNLOADS_BLACK_SVG, TOP_DOWNLOADS_SELECTED_SVG, TRASH_SVG, TRASH_BLUE_SVG, VIDEO_SVG, VIDEO_BLACK_SVG, VIDEO_WHITE_SVG, VOLUME_0_SVG, VOLUME_1_SVG, VOLUME_2_SVG, };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/assets/index.js
// module id = 35
// module chunks = 0